<div class="multi-client-table">
    <div class="row multi-client-table-row" *ngFor="let clientRow of clientsTable">
        <div *ngFor="let label of rssiLabels" class="col multi-client-table-col">
            <span class="multi-client-cell-key" [title]="getCellKey(clientRow, label)">
                {{getCellKey(clientRow, label)}}</span>
            <span class="multi-client-cell"
                [title]="getCellValue(clientRow, label)"><strong>{{getCellValue(clientRow, label)}}</strong></span>
        </div>
    </div>
</div>